module.exports = __webpack_public_path__ + "files/b0775fd683a595f0a3a986547406e394.svg";